import { render, staticRenderFns } from "./LedgerProductTab.vue?vue&type=template&id=4215b059"
import script from "./LedgerProductTab.vue?vue&type=script&lang=ts"
export * from "./LedgerProductTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4215b059')) {
      api.createRecord('4215b059', component.options)
    } else {
      api.reload('4215b059', component.options)
    }
    module.hot.accept("./LedgerProductTab.vue?vue&type=template&id=4215b059", function () {
      api.rerender('4215b059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/components/LedgerProductTab.vue"
export default component.exports